import { AppStoreContext } from "@src/stores/AppStore";
import { useContext } from "react";

export const useStore = () => useContext(AppStoreContext);
